import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { getAuthToken, getAuthUser } from 'utils/auth';
import PendingApproval from 'pages/auth/PendingApproval';

export default function AuthGuard({ children }) {
  const location = useLocation();
  const token = getAuthToken();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const status = getAuthUser()?.admin_request_status;
  if (status === 'pending' || status === 'rejected') {
    return <PendingApproval status={status} />;
  }

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.node.isRequired
};
